import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute('/_authenticated/org/$orgId/products')({
  component: ProductsLayout,
})

function ProductsLayout() {
  return <FeatureGate feature='image' />
}
